export default "__VITE_ASSET__Kc9fQ4Rj__"